import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ExplorerHomePage from './Pages/ExplorerHome.page';
import ExplorerTransactionPage from './Pages/ExplorerTransaction.page';
import Dashboard from './Pages/Dashboard.page';
import Explorer from './Pages/Explorer.page';
import ExplorerAppBar from './Components/ExplorerAppBar.component';
import { Box } from '@mui/material';
import UserPage from './Pages/UserPage/UserPage';
import Footer from '../Components/Common/Footer.component';
import Disclaimer from './Components/Disclaimer.component';
import AddressPage from './Pages/Address.page';

export default function ExplorerRouter() {
    return (
        <Box>
            <ExplorerAppBar />
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/explore" element={<Explorer />} />
                <Route path="/transaction/:txId" element={<ExplorerTransactionPage />} />
                <Route path="/user/:userId" element={<UserPage />} />
                <Route path="/address/:address" element={<AddressPage />} />

            </Routes>
            <Footer />
            <Disclaimer />
        </Box>
    );
}
